export const DisplayMode = {
    Desktop: 'desktop',
    Mobile: 'mobile',
} as const;

export type DisplayMode = (typeof DisplayMode)[keyof typeof DisplayMode];
